import loadBoards from './common/load-boards'
import searchLoads from './common/search-loads'

const store = {
  namespaced: true,
  state: {
    ...loadBoards.state,
    ...searchLoads.state
  },
  mutations: {
    ...loadBoards.mutations,
    ...searchLoads.mutations
  },
  actions: {
    ...loadBoards.actions,
    ...searchLoads.actions
  }
}

export default store